var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('upload-files',{attrs:{"contentFiles":_vm.contentImages,"accept":'image/png, image/jpeg'},on:{"uploadsFinished":function($event){return _vm.uploadOnDatabase($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }